import React from 'react'
import MenuAdmin from './navAdmin/Menu'
import Contact from '../public/Contact'
function ContactAdmin() {
    return (
        <div>
            <MenuAdmin menuActive={'contact'} />
            <Contact disabledMenu/>
        </div>
    )
}

export default ContactAdmin